'use client';

import { usePathname, useRouter } from 'next/navigation';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@natu/ui/Select';
import { getSlugWithDash } from '@natu/utils/getSlugWithDash';

import { useCategoryBar } from './getCategoryBarItems';
import { CategoriesProps } from './types';

export const MobileCategories = ({ categoryItems }: CategoriesProps) => {
  const { push } = useRouter();
  const pathname = usePathname();
  const { data, isEmpty } = useCategoryBar({ categoryItems });

  if (isEmpty) {
    return null;
  }

  const handleChange = (value: string) => {
    const path = getSlugWithDash(value);
    push(path);
  };

  const selectedValue = data.find(item => getSlugWithDash(item?.fullSlug) === pathname)?.fullSlug;

  return (
    <Select value={selectedValue} onValueChange={handleChange}>
      <SelectTrigger className="font-semibold text-gray-500 lg:hidden" aria-label="Blog categories">
        <SelectValue placeholder="Categories" />
      </SelectTrigger>
      <SelectContent>
        {data.map(category => (
          <SelectItem key={category.uuid} value={category.fullSlug}>
            {category.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
